export default "__VITE_ASSET__ChVzu9$2__"